import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Tabs, Tab, Backdrop, CircularProgress, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import Pagination from "@mui/material/Pagination";
import { makeStyles } from "@mui/styles";
import {
  Form,
  Row,
  Col,
  FormGroup,
  Label,
  Input,
  Table,
} from "reactstrap"; 
import axios from "axios";
import NavbarNew from "../Navbar/NavbarNew";
import DateRangePicker from "react-bootstrap-daterangepicker";
import base_url from "../api/bootapi";
import { SwapVert } from "@mui/icons-material";
import moment from "moment";
import AdminSidebar from "../Account/MyAccount/AdminSidebar";
import { LeadContext } from "../ContextAPI/LeadContext";

const useStyles = makeStyles(() => ({
  backdrop: {
    zIndex: 1000,
    color: "#fff",
  },
}));

// --- Change this if your backend uses a different URL ---
const LIST_URL = `${base_url.api5}/getAllClientTempWithNewPage`;
function LeadList() {
  const clientdetails = JSON.parse(
    localStorage.getItem("isw_client_details_frontend")
  );

  const { leadsData, setLeadsData } = useContext(LeadContext);

  const handlesidebartab = (val) => {
     // If they click Profile/Mail from here, take them back to the main dashboard
     navigate("/myaccount");
  };
  const navigate = useNavigate();
  const classes = useStyles();
  const [backDropOpen, setBackDropOpen] = useState(false);
  const [service, setService] = useState("Admission");

  const [branch, setBranch] = useState("");
  const [status, setStatus] = useState("all");
  const [source, setSource] = useState("");
  const [dateValue, setDateValue] = useState("Click to open");
  const [createdStartDate, setCreatedStartDate] = useState(null);
  const [createdToDate, setCreatedEndDate] = useState(null);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(20);
  const [totalUser, settotalUser] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [numberofElements, setnumberofElements] = useState(0);

  const [pageno, setpageno] = useState(0);
  const [sortState, setsortState] = useState("id");
  const [direction, setdirection] = useState("DESC");

  const [remarksOpen, setRemarksOpen] = useState(false);
  const [remarksHtml, setRemarksHtml] = useState(""); 
  const [remarksLeadId, setRemarksLeadId] = useState(null); 
  const editorRef = useRef(null); 

  const getallLeads = async () => {
    try {
      setBackDropOpen(true);

      let headData = {
        Authorization: `Bearer ${clientdetails.token}`,
        columnName: "updatedOn",
        direction: direction,
        interestedService: service,
        query: search,                
        officeId: branch,
        clientSource: source,
        createdStartDate: createdStartDate,
        createdEndDate: createdToDate,
        officeId: branch,
        status: status,
        page: Number(pageno),
        size: Number(limit),  
      };

      const cleanedHeaders = Object.fromEntries(
        Object.entries(headData).filter(([k, v]) => {
          if (v === null || v === undefined) return false;
          if (typeof v === "string" && v.trim() === "") return false;
          if (k === "status" && (v === "all" || v === "")) return false;
          return true;
        })
      );
      let resp;
      try {
        resp = await axios.get(LIST_URL, {
          headers: cleanedHeaders, 
          
        });
      } catch (e) {
        throw e;
      }

      const payload = resp?.data?.data ?? resp?.data ?? {};
      const content = payload?.content ?? [];
      const totalElements = payload?.totalElements ?? 0;
      const totalPagesLocal = payload?.totalPages ?? 0;
      const numberOfElements = payload?.numberOfElements ?? content.length;
      console.log("Leads Data:", content);
      setLeadsData(content);
      settotalUser(totalElements);
      settotalPages(totalPagesLocal);
      setnumberofElements(numberOfElements);
    } catch (err) {
      console.error("Failed to fetch leads:", err);
      setLeadsData([]);
      settotalUser(0);
      settotalPages(0);
      setnumberofElements(0);
    } finally {
      setBackDropOpen(false);
    }
  };

  useEffect(() => {
    if (typeof limit !== "number") setLimit(Number(limit));
    getallLeads();
  }, [
    service,      
    direction,    
    pageno,      
    sortState,
  ]);

  const handleChange = (event, newValue) => setService(newValue);

  const handleCallback = (start, end) => {
    setDateValue(
      `${start.format("DD-MM-YYYY")} to ${end.format("DD-MM-YYYY")}`
    );
  };

  const handleApply = (event, picker) => {
    setDateValue(
      `${picker.startDate.format("DD-MM-YYYY")} to ${picker.endDate.format(
        "DD-MM-YYYY"
      )}`
    );
    setCreatedStartDate(picker.startDate.format("YYYY-MM-DD"));
    setCreatedEndDate(picker.endDate.format("YYYY-MM-DD"));
  };

  const handleClearDate = () => {
    setDateValue("Click to open");
    setCreatedStartDate(null);
    setCreatedEndDate(null);
    setpageno(0);
    
  };

  const handleSort = (e) => {
    setsortState(e.target.id);
    if (direction === "DESC") {
      setdirection("ASC");
    } else if (direction === "ASC") {
      setdirection("DESC");
    }
  };

  const handleSearch = (e) => {
    e.preventDefault();
    setpageno(0);
    getallLeads();
  };

  const handleReset = () => {
    setLimit(20);
    setBranch("");
    setStatus("all");
    setSource("");
    setDateValue("Click to open");
    setSearch("");
    setCreatedStartDate(null);
    setCreatedEndDate(null);
    setpageno(0);
    getallLeads();
  };

  const exec = (cmd) => {
    if (!remarksOpen) return;
    document.execCommand(cmd, false, null);
    if (editorRef.current) {
      setRemarksHtml(editorRef.current.innerHTML);
    }
  };


  function TabPanel({ value, index, component }) {
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
      >
        {value === index && component}
      </div>
    );
  }

  return (
    <div>
      <Backdrop className={classes.backdrop} open={backDropOpen}>
        <CircularProgress color="inherit" />
      </Backdrop>

   {remarksOpen && (
  <div
    className="modal fade show"
    tabIndex={-1}
    role="dialog"
    onClick={() => setRemarksOpen(false)}
    style={{
      position: "fixed",
      inset: 0,
      background: "rgba(0,0,0,0.5)",
      display: "block",
      zIndex: 20000,
      overflow: "hidden",
    }}
  >
    <div
      className="modal-dialog modal-lg modal-dialog-centered"
      role="document"
      onClick={(e) => e.stopPropagation()}
      style={{
        maxWidth: "900px",
        width: "90%",
        margin: "0 auto",
      }}
    >
      <div
        className="modal-content"
        style={{
          height: "70vh",            
          display: "flex",
          flexDirection: "column",
          position: "relative",
        }}
      >
        <div className="modal-header" style={{ flex: "0 0 auto" }}>
          <h5 className="modal-title">Remark</h5>
          <button
            type="button"
            className="close btn"
            onClick={() => setRemarksOpen(false)}
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>

        <div
          style={{
            padding: "8px 16px",
            borderBottom: "1px solid #eee",
            flex: "0 0 auto",
          }}
        >
          <div className="d-flex align-items-center" style={{ gap: 8 }}>
            <button className="btn btn-sm btn-light" onClick={() => exec("bold")}>B</button>
            <button className="btn btn-sm btn-light" onClick={() => exec("italic")}>I</button>
            <button className="btn btn-sm btn-light" onClick={() => exec("underline")}>U</button>
            <button className="btn btn-sm btn-light" onClick={() => exec("strikeThrough")}>S</button>
            <button className="btn btn-sm btn-light" onClick={() => exec("insertUnorderedList")}>•</button>
            <button className="btn btn-sm btn-light" onClick={() => exec("insertOrderedList")}>1.</button>
            <button
              className="btn btn-sm btn-light"
              onClick={() => {
                if (!editorRef.current) return;
                editorRef.current.innerHTML = "";
                setRemarksHtml("");
              }}
            >
              ⨯
            </button>
          </div>
        </div>

        <div
          className="modal-body"
          style={{
            flex: "1 1 auto",
            overflowY: "auto",
            paddingTop: 12,
          }}
        >
          <div
            ref={editorRef}
            contentEditable
            suppressContentEditableWarning
            onInput={(e) => setRemarksHtml(e.currentTarget.innerHTML)}
            style={{
              border: "1px solid #dee2e6",
              borderRadius: 6,
              minHeight: 280,
              padding: 12,
              wordBreak: "break-word",
              background: "#fff",
              lineHeight: 1.4,
              fontSize: 14,
            }}
            dangerouslySetInnerHTML={{ __html: remarksHtml }}
          />
        </div>

        <div className="modal-footer" style={{ flex: "0 0 auto" }}>
          <button className="btn btn-secondary" onClick={() => setRemarksOpen(false)}>
            Cancel
          </button>
          <button className="btn btn-green" onClick={() => setRemarksOpen(false)}>
            Update
          </button>
        </div>
      </div>
    </div>
  </div>
)}



      <NavbarNew />

      {/* LAYOUT WRAPPER START */}
      <div className="mainaccount">
        {/* LEFT SIDEBAR */}
        <div className="mainaccount_left">
          <AdminSidebar
            sidebartab="leadlist"
            handlesidebartab={handlesidebartab}
          />
        </div>

        {/* RIGHT CONTENT AREA */}
        <div className="mainaccount_right">
        <div style={{ paddingTop: "80px", paddingLeft: "60px", paddingRight: "60px" }}>
          <h1 className="page-title text-center mb-4" style={{ fontWeight: 'bold' }}>Manage Leads</h1>

        <Tabs
          value={service}
          onChange={handleChange}
          indicatorColor="primary"
          textColor="primary"
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab value="Admission" label="Admission" />
          <Tab value="Migration" label="Migration" />
          <Tab value="Insurance" label="Insurance" />
          <Tab value="SkillAssessment" label="Skill Assessment" />
        </Tabs>

        <Form id="filtersForm" className="p-3" onSubmit={handleSearch}>
          <Row className="gy-3 gx-4 align-items-center">
            <Col md={1}>
              <FormGroup controlId="limitSelect">
                <Label>Limit</Label>
                <select
                  className="form-control"
                  value={limit}
                  onChange={(e) => setLimit(Number(e.target.value))}
                >
                    {[10, 20, 50, 100].map((num) => (
                      <option key={num} value={num}>
                        {num}
                      </option>
                    ))}
                </select>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup controlId="branchSelect">
                <Label>Branch</Label>
                <select
                  className="form-control"
                  value={branch}
                  onChange={(e) => setBranch(e.target.value)}
                >
                  <option value="" id="all">
                    - Show All -
                  </option>
                </select>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup controlId="statusSelect">
                <Label>Status</Label>
                <select
                  className="form-control"
                  value={status}
                  onChange={(e) => setStatus(e.target.value)}
                >
                  <option value="">All</option>
                  <option value="1">Unarchive</option>
                  <option value="0">Archive</option>
                </select>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup controlId="sourceSelect">
                <Label>Source</Label>
                <select
                  className="form-control"
                  value={source}
                  onChange={(e) => setSource(e.target.value)}
                >
                  <option value="">- Select Source -</option>
                  <option value="In-house App">In-house App</option>
                  <option value="Referral">Referral</option>
                  <option value="Social Media">Social Media</option>
                  <option value="Sub Agent">Sub Agent</option>
                  <option value="Website">Website</option>
                </select>
              </FormGroup>
            </Col>

           <Col md={3}>
              <FormGroup controlId="dateRange">
                <Label>Date</Label>
                {/* Use a wrapper div for positioning the icon */}
                <div style={{ position: "relative" }}>
                  <DateRangePicker
                    className="form-control"
                    onCallback={handleCallback}
                    onApply={handleApply}
                  >
                    {/* This div is the clickable date range text */}
                    <div
                      className="form-control form-control-sm text-center"
                      style={{ 
                        backgroundColor: "#f5f5f9", 
                        cursor: "pointer", 
                        paddingRight: "30px" // Add padding to prevent text from overlapping icon
                      }}
                    >
                      {dateValue}
                    </div>
                  </DateRangePicker>
                  
                  {/* This is the new Clear Icon */}
                  {createdStartDate && ( // Only show icon if a date is set
                    <IconButton
                      aria-label="clear date"
                      onClick={handleClearDate}
                      style={{
                        position: 'absolute',
                        right: '5px', // Position inside the input area
                        top: '50%',
                        transform: 'translateY(-50%)',
                        zIndex: 100, // Ensure it's on top
                      }}
                      size="small"
                    >
                      <ClearIcon fontSize="small" />
                    </IconButton>
                  )}
                </div>
              </FormGroup>
            </Col>

            <Col md={2}>
              <FormGroup controlId="searchInput">
                <Label>Search</Label>
                <Input
                  className="form-control"
                  type="text"
                  placeholder="Search..."
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </FormGroup>
            </Col>

            <Col
              md={12}
              className="d-flex justify-content-end gap-2 mt-2 btns-group"
            >
              <button
                type="reset"
                className="btn btn-green"
                onClick={handleReset}
              >
                Reset
              </button>
              <button type="submit" className="btn btn-green">
                Submit Now
              </button>
            </Col>
          </Row>
        </Form>

        <Table
          className="leads_table card-table table-borderless s_table"
          responsive
        >
          <thead>
            <tr style={{ color: "#6d7290", whiteSpace: "nowrap" }}>
              <th
                style={{ width: "50px", textAlign: "center" }}
                className="d-flex table-heading"
              >
                SN
              </th>
              <th style={{ minWidth: "95px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  DATE
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "90px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  QUEUE
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "120px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  CLIENT
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "100px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  CONTACT
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "100px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  COUNTRY
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "115px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  SERVICES
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "120px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  SOURCE
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "130px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  CONSULTANT
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "100px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  BRANCH
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "115px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  FOLLOW-UP
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "100px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  DEPOSIT
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "130px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  CREATED BY
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "103px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  UPDATED DATE
                  <SwapVert />
                </div>
              </th>
              <th style={{ minWidth: "110px" }}>
                <div className="d-flex table-heading" onClick={handleSort}>
                  REMARKS
                  <SwapVert />
                </div>
              </th>
              <th
                style={{ minWidth: "100px" }}
                className="d-flex table-heading"
              >
                ACTION
              </th>
            </tr>
          </thead>

          {leadsData != null ? (
            <tbody>
              {leadsData?.map((p, index) => (
                <tr key={p.id} className="s_tr">
                  <td style={{ width: "50px", textAlign: "center" }}>
                    {pageno * Number(limit) + index + 1}
                  </td>
                  <td>
                    {p.addedOn
                      ? moment(p.addedOn.split("T")[0]).format("DD-MMM-YY")
                      : null}
                  </td>
                  <td>{p.days_in_queue}</td>

                  <td>
                    <div>
                      <span>
                        {`${p.firstName || ""} ${p.lastName || ""}`.trim()}
                      </span>
                    </div>
                    {p.email ? (
                      <div
                        style={{
                          color: "#6c757d",
                          fontSize: "12px",
                          wordBreak: "break-word",
                        }}
                      >
                        {p.email}
                      </div>
                    ) : null}
                  </td>

                  <td>
                    <div
                      style={{
                        width: "90px",
                        wordWrap: "break-word",
                        display: "inline-block",
                      }}
                    >
                      {p.phone == 0 ? " " : p.phone}
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        width: "100px",
                        wordWrap: "break-word",
                        display: "inline-block",
                      }}
                    >
                      {p.city}
                    </div>
                    <br />
                    <div
                      style={{
                        width: "100px",
                        wordWrap: "break-word",
                        display: "inline-block",
                      }}
                    >
                      {p.country}
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        width: "90px",
                        wordWrap: "break-word",
                        display: "inline-block",
                      }}
                    >
                      {p.interestedServices}
                    </div>
                  </td>
                  <td>{p.clientSource}</td>
                  <td>
                    <div className="s_tooltip">
                      {p.assigneeName != null
                        ? p.assigneeName.split(" ")[0]
                        : ""}
                      <span className="s_tooltiptext">{p.assigneeName}</span>
                    </div>
                  </td>
                  <td>
                    <div
                      style={{
                        width: "90px",
                        wordWrap: "break-word",
                        display: "inline-block",
                      }}
                    >
                      {p.officeName}
                    </div>
                    <br />
                    <div
                      style={{
                        width: "90px",
                        wordWrap: "break-word",
                        display: "inline-block",
                      }}
                    >
                      {p.officeCountry}
                    </div>
                  </td>
                  <td>
                    {p.followUpOn
                      ? moment(p.followUpOn.split(".")[0]).format("DD-MMM-YY")
                      : null}
                  </td>
                  <td>{p.deposit === 1 ? "Yes" : "No"}</td>

                  <td>
                    <div className="s_tooltip">
                      {p.createdBy != null ? p.createdBy.split(" ")[0] : ""}
                      <span className="s_tooltiptext">
                        <div
                          style={{
                            width: "120px",
                            wordWrap: "break-word",
                            display: "inline-block",
                          }}
                        >
                          {p.createdBy}
                        </div>
                      </span>
                    </div>
                  </td>
                  <td>
                    {p.updatedOn
                      ? moment(p.updatedOn.split(".")[0]).format("DD-MMM-YY")
                      : null}
                  </td>

                  <td>
                    {(() => {
                      const raw = p?.remarks ?? "";
                      const normalized =
                        typeof raw === "string"
                          ? raw.trim()
                          : String(raw ?? "").trim();
                      return normalized ? (
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() => {
                            setRemarksLeadId(p.id);
                            setRemarksHtml(normalized);
                            setRemarksOpen(true);
                            setTimeout(() => {
                              if (editorRef.current) {
                                const range = document.createRange();
                                range.selectNodeContents(editorRef.current);
                                range.collapse(false);
                                const sel = window.getSelection();
                                sel.removeAllRanges();
                                sel.addRange(range);
                              }
                            }, 50);
                          }}
                        >
                          View
                        </button>
                      ) : (
                        <span className="text-muted">—</span>
                      );
                    })()}
                  </td>

                  <td id={p.id}>
                    <button
                      className="btn btn-green"
                      onClick={() => navigate(`/create_client_lead/${p.id}`)}
                    >
                      Convert
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          ) : null}
        </Table>

        <div className="py-4">
          <Row className="align-items-center gy-3">
            <Col xs="12" md="4" lg="3">
              <FormGroup className="mb-0 d-flex align-items-center">
                <Input
                  id="limitSelect"
                  type="select"
                  bsSize="sm"
                  value={limit}
                  onChange={(e) => setLimit(Number(e.target.value))}
                  style={{ width: "100px" }}
                >
                  {[10, 20, 50, 100].map((num) => (
                    <option key={num} value={num}>
                      {num}
                    </option>
                  ))}
                </Input>
              </FormGroup>
            </Col>

            <Col xs="12" md="4" className="text-center">
              {leadsData?.length ? (
                <div className="text-muted small">
                  Showing {totalUser === 0 ? 0 : pageno * Number(limit) + 1} to{" "}
                  {pageno * Number(limit) + numberofElements} of {totalUser} records
                </div>
              ) : (
                <div className="text-muted small">No Record Found</div>
              )}
            </Col>

            <Col xs="12" md="4" lg="5" className="d-flex justify-content-end">
              <Pagination
                page={pageno + 1}
                count={totalPages}
                onChange={(e, value) => setpageno(value - 1)}
                shape="rounded"
              />
            </Col>
          </Row>
        </div>
      </div>
    </div>
    </div>
    </div>
  );
}

export default LeadList;
